import React, { FC } from 'react';
import { PAYWALL_LAYOUT_VERSION } from './types';
import { PAYWALL_LAYOUT } from './variants';

interface Props {
	version: PAYWALL_LAYOUT_VERSION;
	children: React.ReactNode;
}

export const PaywallLayout: FC<Props> = props => {
	const { version, children } = props;
	return PAYWALL_LAYOUT[version](children);
};
